import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@libs/ui-lib';
import { FfdNoteItem } from '@libs/ffd-notes';
import { FfdNoteItemComponent } from '../ffd-note-item';

@Component({
  selector: 'lib-ffd-note-visit',
  imports: [CommonModule, SvgIconComponent, TranslateModule, TooltipModule, FfdNoteItemComponent],
  templateUrl: './ffd-note-visit.component.html',
  styleUrl: './ffd-note-visit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNoteVisitComponent {
  public readonly items = input<FfdNoteItem[]>([]);
  public readonly visitDate = input<string | null | undefined>(null);
  public readonly closeOnSelect = input<boolean>(false);
  public readonly disabled = input<boolean>(false);
  public readonly visitId = input<string>('');
  public readonly searchTerm = input<string | null | undefined>(null);
  public readonly expandableNotes = input<boolean>(false);
  public readonly isTimeZoneDifferentFromLocal = input<boolean>(false);
  public readonly editingNoteId = input<string | null>(null);
  public readonly hideNoteMenu = input<boolean>(false);
  public readonly selectedNoteId = input<string | null>(null);
  public visitDateClick = output<string>();
  public noteClick = output<string>();
  public editNoteClick = output<string>();
  public deleteNoteClick = output<string>();

  protected onNoteClick(noteId: string): void {
    this.noteClick.emit(noteId);
  }

  protected onEditNoteClick(noteId: string): void {
    this.editNoteClick.emit(noteId);
  }

  protected onDeleteNoteClick(noteId: string): void {
    this.deleteNoteClick.emit(noteId);
  }
}
